import { render, staticRenderFns } from "./ShapeBgCard.vue?vue&type=template&id=0f31c469&"
import script from "./ShapeBgCard.vue?vue&type=script&lang=js&"
export * from "./ShapeBgCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports